<template>
    <div class="page-list">
        <v-container>
            <v-row dense>
                <v-col cols="12" md="6"><h2>Pages List</h2></v-col>
                <v-col cols="12" md="6" class="text-end">
                    <v-btn color="secondary" small @click="addDialog = true">Add New Page</v-btn>
                </v-col>
            </v-row>
            <v-card>
                <v-data-table :items="allpages" :headers="pageHeaders">
                    <template v-slot:item.page_content="{item}">
                        <div v-html="item.page_content" class="h250"></div>
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn color="info" small @click="editItem(item)">Edit</v-btn>
                    </template>
                </v-data-table>
            </v-card>
            <v-dialog v-model="addDialog" max-width="800">
                <v-card>
                    <v-card-text>
                        <v-form ref="pform" v-model="pvalid">
                            <v-text-field v-model="defaultItem.page_name" label="Page Name" :rules="nameRules"></v-text-field>
                            <quill-editor v-model="defaultItem.quillContent"></quill-editor>
                            <div class="d-flex mt-2 gap-2">
                                <v-spacer/>
                                <v-btn :disabled="!pvalid" color="success" small @click="addnewPage">Submit Page</v-btn>
                                <v-btn color="red" dark small @click="addDialog = false">Cancel</v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="editDialog" max-width="800">
                <v-card>
                    <v-card-text>
                        <v-form ref="pform" v-model="uvalid">
                            <v-text-field v-model="editedItem.page_name" label="Page Name" :rules="nameRules"></v-text-field>
                            <quill-editor v-model="editedItem.page_content"></quill-editor>
                            <div class="d-flex mt-2 gap-2">
                                <v-spacer/>
                                <v-btn :disabled="!uvalid" color="success" small @click="editPage">Update Page</v-btn>
                                <v-btn color="red" dark small @click="editDialog = false">Cancel</v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
import QuillEditor from "../components/QuillEditor.vue";
export default {
    name:"AdminPages",
    components:{QuillEditor},
    data(){
        return{
            pvalid:false,
            uvalid:false,
            addDialog:false,
            editDialog:false,
            allpages:[],
            pageHeaders:[
                {text:"ID",value:'page_id'},
                {text:"Name",value:'page_name'},
                {text:"Slug",value:'page_slug'},
                {text:"Content",value:'page_content',maxWidth:'60'},
                {text:"Status",value:'page_status'},
                {text:"Actions",value:'actions'},
            ],
            quillContent: '',
            defaultIndex:-1,
            defaultItem:{
                page_name:'',
                quillContent:'',
                page_status:'active',
            },
            editedIndex:-1,
            editedItem:{
                page_id:'',
                page_name:'',
                page_content:'',
                page_status:'active',
            },
            nameRules: [
                v => !!v || "Page name is required",
                v => (v && v.length <= 80) || "Page name must be less than 80 characters"
            ],
        }
    },
    created() {
        this.getPages();
    },
    methods:{
        getPages(){
            axios.get('/admin/pages/vlist')
                .then((resp)=>{
                    this.allpages = resp.data.pages;
                })
        },
        addnewPage(){
            const npage = {
                'page_name':this.defaultItem.page_name,
                'page_content':this.defaultItem.quillContent,
                'page_status':this.defaultItem.page_status,
            }
            const fhead = {
                "headers": {
                    "Content-Type": "application/json"
                }
            }
            axios.post('/admin/page/create',npage,fhead)
                .then((resp)=>{
                    console.log(resp.data);
                    this.getPages();
                    this.addDialog = false;
                })
        },
        editItem(item){
            this.editedIndex = this.allpages.indexOf(item);
            this.editedItem = Object.assign({},item)
            this.editDialog = true;
        },
        editPage(){
            const upage = {
                'page_id':this.editedItem.page_id,
                'page_name':this.editedItem.page_name,
                'page_slug':this.editedItem.page_slug,
                'page_content':this.editedItem.page_content,
                'page_status':this.editedItem.page_status,
            }
            const fhead = {
                "headers": {
                    "Content-Type": "application/json"
                }
            }
            console.log('upage',upage)
            axios.post('/admin/page/create',upage,fhead)
                .then((resp)=>{
                    console.log(resp.data);
                    this.getPages();
                    this.editDialog = false;
                })
        }
    }
}

</script>
<style scoped>
.v-application .h250 {
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    overflow: auto;
    max-height: 250px;
    max-width: 350px;
}
</style>
